import { cn } from '@/lib/utils';

/** No focus ring on list filters — Radix Select stays focused while open (double blue outline). */
const LIST_FILTER_FOCUS_CLASS =
  'outline-none ring-0 ring-offset-0 focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 data-[state=open]:ring-0 data-[state=open]:ring-offset-0';

/** Single solid outline when a list filter value is applied (not the default "all"). */
export const ACTIVE_LIST_FILTER_CLASS = 'border-2 border-primary shadow-none';

export function activeListFilterClass(active: boolean, className?: string): string {
  return cn(className, LIST_FILTER_FOCUS_CLASS, active && ACTIVE_LIST_FILTER_CLASS);
}
